import Col from '@loggi/ui/components/col';
import Icon from '@loggi/ui/components/icon';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './address-text.styles.scss';

export const ADDRESS_TEXT_ID = 'address-text';

export default function AddressText({
  name,
  firstLine,
  secondLine,
  complement,
  gutter,
  firstLineColor,
  hasIcon
}) {
  return (
    <Col
      className={styles.destinationInfo}
      flexDirection="row"
      gutter={gutter}
      data-testid={ADDRESS_TEXT_ID}
    >
      {hasIcon && (
        <Col className={styles.addressIcon}>
          <Icon type={icons.type.PIN} color={colors.type.STORM_500} />
        </Col>
      )}
      <Col flexDirection="column" className="destination-info-detail">
        {name && (
          <Text size="400" color={firstLineColor}>
            {name}
          </Text>
        )}
        <Text size="400" color={firstLineColor}>
          {firstLine}
        </Text>
        <Text size="300" color={colors.type.STORM_500}>
          {secondLine}
        </Text>
        {Boolean(complement) && (
          <Text size="300" color={colors.type.STORM_500}>
            {complement}
          </Text>
        )}
      </Col>
    </Col>
  );
}

AddressText.displayName = 'AddressText';
AddressText.defaultProps = {
  name: null,
  complement: null,
  hasIcon: false,
  gutter: null,
  firstLineColor: colors.type.SMOKE_900
};
AddressText.propTypes = {
  name: PropTypes.string,
  firstLine: PropTypes.string.isRequired,
  secondLine: PropTypes.string.isRequired,
  complement: PropTypes.string,
  hasIcon: PropTypes.bool,
  gutter: PropTypes.shape({
    top: PropTypes.string,
    right: PropTypes.string,
    bottom: PropTypes.string,
    left: PropTypes.string
  }),
  firstLineColor: PropTypes.string
};
